import { render, staticRenderFns } from "./ScenicMapPointsManage.vue?vue&type=template&id=3c237e76"
import script from "./ScenicMapPointsManage.vue?vue&type=script&lang=js"
export * from "./ScenicMapPointsManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports